import { useDispatch } from 'react-redux'

import { useGetUserQuery } from 'common'
import {
  BILLING_ENTRYPOINTS,
  moveToChangeSubscription,
  NOTETAKER_FREE_MEETINGS_PAYWALL_FEATURE,
  setAnalyticsLocation
} from 'features/billing'
import { useGetNotetakerFreeMeetingsQuotaQuery, useGetMeetingIntelligenceUserSettingsQuery } from 'features/meeting_intelligence/api'
import { useEnableNotetakerWithLoader } from 'features/meeting_intelligence/hooks'
import { useNotetakerUpsellUIVisible } from 'hooks/notetaker_visibility'
import { useNotetakerFiveFreeRecapsExperiment } from 'hooks/useNotetakerFiveFreeRecapsExperiment'

import { FreeRecapsInlineBannerView } from './free_recaps_inline_banner_view'
import { normalizeRecapsUsage } from './helpers'

export const FreeRecapsInlineBanner = () => {
  const dispatch = useDispatch()
  const enableNotetaker = useEnableNotetakerWithLoader()
  const {
    isVisible: upsellUiVisible,
    isLoading: isUpsellUiVisibilityLoading
  } = useNotetakerUpsellUIVisible()
  const { isInExperiment } = useNotetakerFiveFreeRecapsExperiment(
    upsellUiVisible && !isUpsellUiVisibilityLoading
  )
  const { data: userData } = useGetUserQuery()
  const shouldSkipUpsellRequests = !isInExperiment
    || !upsellUiVisible
    || isUpsellUiVisibilityLoading
    || !userData?.uuid

  const { data: featureAvailability, isLoading, error } = useGetNotetakerFreeMeetingsQuotaQuery(
    { userUuid: userData?.uuid },
    { skip: shouldSkipUpsellRequests }
  )
  const featureAvailabilityDetails = featureAvailability?.resource?.details
  const featureAvailable = featureAvailability?.resource?.featureAvailable

  const { data: meetingIntelligenceData } = useGetMeetingIntelligenceUserSettingsQuery(undefined, {
    skip: shouldSkipUpsellRequests
  })
  const isMiEnabled = meetingIntelligenceData?.miEnabled

  const handleUpgrade = () => {
    dispatch(setAnalyticsLocation(BILLING_ENTRYPOINTS.RECAPS_DETAIL_PAGE))
    dispatch(moveToChangeSubscription({
      featureKey: 'meeting_intelligence',
      preface: true,
      quotaAnalytics: {
        name: NOTETAKER_FREE_MEETINGS_PAYWALL_FEATURE,
        ...(featureAvailable !== undefined && { quotaReached: !featureAvailable })
      },
      ...(isMiEnabled === false && { onSuccess: enableNotetaker })
    }))
  }

  if (!isInExperiment || !upsellUiVisible || isUpsellUiVisibilityLoading) {
    return null
  }

  if (isLoading || error) {
    return null
  }

  if (!featureAvailabilityDetails) {
    return null
  }

  const normalized = normalizeRecapsUsage(featureAvailabilityDetails)

  if (!normalized) {
    return null
  }

  const { usedRecaps, recapsQuota } = normalized

  return (
    <FreeRecapsInlineBannerView
      usedRecaps={usedRecaps}
      recapsQuota={recapsQuota}
      onUpgrade={handleUpgrade}
    />
  )
}
